import {isValueNotEmptyMessage} from 'src/components/pages/PipelinesPages/utils/validators'

export const pipelineNameValidators = [
  {
    validator: isValueNotEmptyMessage,
    message: 'Pipeline name should not be empty',
  },
]
